import paymentMethodsIdMap from '../components/legal-entity/payment-method-id-map';
import {getSelectedPaymentOption} from './selectors';

export default (state) => {
  const entities = state.start.legalEntities?.entities;
  const isSelectedPaymentTypeAdyenV2 = getSelectedPaymentOption(state)?.isAdyenV2Option;
  const paymentOptionTypeOrNameToLookup = isSelectedPaymentTypeAdyenV2 ? 'ADYEN_V2' : state.payment.paymentOptionName;
  
  if (entities) {
    const paymentOptionTypeOrName = paymentMethodsIdMap(paymentOptionTypeOrNameToLookup);
    return entities[paymentOptionTypeOrName];
  }
  
  return null;
};
